import { CalendarCheck, Check } from "lucide-react";
import { Badge, Stack } from "react-bootstrap";
import './../../App.css'; 

export default function AppointmentStatus() {

    return (
        <div>
            <form className="row g-3 card-body">
                <Stack direction="horizontal" gap={2}>
                    <Badge pill bg="info">Agendada
                        <CalendarCheck size={15} />
                    </Badge>
                    <Badge pill bg="primary">Confirmada
                        <Check size={15} />
                    </Badge>
                    <Badge pill bg="success">Realizada
                        <Check size={15} />
                    </Badge>
                </Stack>
            </form>
        </div>
    );
}